import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { BrandOption, BrandingData, FontCSS, HomePageTextBlock, JoiTemplate, getJoiTemplate } from 'globals/store/publish.data';
import { SocialLinksComponent } from '../social-links/social-links.component';
import { CommonModule } from '@angular/common';
import { ImagePlaceholderComponent } from './image-placeholder.component';
import { FooterLinksComponent } from './footer-links.component';
import { MatButtonModule } from '@angular/material/button';

// Will take in everything needed for branding - template, headers and footers, etc.  To be used both in app and on share pages.
@Component({
    selector: 'branding-wrapper',
    template: `
<div class="branding-wrapper" *ngIf="{ template: brandingData?.template || joiTemplate } as vars"
  [style.--pagebackground]="vars.template.pagebackground"
  [style.--font]="FontCSS[vars.template.font]"
  [style.--header-font]="FontCSS[vars.template.headerFont]"
  [style.--primary]="vars.template.primary"
  [style.--primaryhover]="vars.template.primaryhover"
  [style.--link]="vars.template.link"
  [style.--contentbg]="vars.template.contentbg"
  [style.--contentbgoutline]="vars.template.contentbgoutline"
  [style.--innercontentbg]="vars.template.innercontentbg"
  [style.--innercontentbgoutline]="vars.template.innercontentbgoutline"
>
  <ng-container *ngIf="!hideAll && !hideHeader">
    <img class="desktop banner header" *ngIf="!isApp && !!brandingData?.header?.link" [ngClass]="{ configure: isConfigure }" [src]="brandingData.header.link" (click)="change.emit('header')"/>
    <img class="mobile banner header" *ngIf="!isApp && !!brandingData?.header?.mobileLink" [ngClass]="{ configure: isConfigure }" [src]="brandingData.header.mobileLink" (click)="change.emit('header')"/>
    <img class="app banner header" *ngIf="!!isApp && !!brandingData?.header?.mobileLink" [ngClass]="{ configure: isConfigure }" [src]="brandingData.header.mobileLink" (click)="change.emit('header')"/>

    <image-placeholder class="desktop header" *ngIf="!isApp && isConfigure && !brandingData?.header?.link" [icon]="'scenic'" [text]="'HEADER IMAGE PLACEHOLDER'" (click)="change.emit('header')"></image-placeholder>
    <image-placeholder class="mobile header" *ngIf="!isApp && isConfigure && !brandingData?.header?.mobileLink" [icon]="'scenic'" [text]="'HEADER IMAGE PLACEHOLDER'" (click)="change.emit('header')"></image-placeholder>
    <image-placeholder class="header" *ngIf="!!isApp && isConfigure && !brandingData?.header?.mobileLink" [icon]="'scenic'" [text]="'HEADER IMAGE PLACEHOLDER'" (click)="change.emit('header')"></image-placeholder>

  </ng-container>
  <ng-content></ng-content>
  <ng-container *ngIf="!hideAll && !hideSocial">
    <social-links *ngIf="brandingData?.social?.social?.length" [ngClass]="{ configure: isConfigure }" [socialLinks]="brandingData.social.social" (click)="changeSocial($event)"></social-links>
    <image-placeholder *ngIf="isConfigure && !brandingData?.social?.social?.length" class="links" [text]="'SOCIAL LINKS PLACEHOLDER'" (click)="change.emit('social')"></image-placeholder>
  </ng-container>
  <ng-container *ngIf="!hideAll && !hideFooterLinks">
    <image-placeholder *ngIf="isConfigure && !brandingData?.footerLinks?.links?.length" class="footerLinks" [icon]="'link12'" [text]="'FOOTER LINKS PLACEHOLDER'" (click)="change.emit('footerLinks')"></image-placeholder>
    <footer-links *ngIf="!!brandingData?.footerLinks?.links?.length" [footerLinks]="brandingData.footerLinks" [ngClass]="{ configure: isConfigure }" (click)="change.emit('footerLinks')"></footer-links>
  </ng-container>

  <ng-container *ngIf="!hideAll && !hideFooter">

    <img class="desktop banner footer" *ngIf="!isApp && !!brandingData?.footer?.link" [ngClass]="{ configure: isConfigure }" [src]="brandingData.footer.link" (click)="change.emit('footer')" />
    <img class="mobile banner footer" *ngIf="!isApp && !!brandingData?.footer?.mobileLink" [ngClass]="{ configure: isConfigure }" [src]="brandingData.footer.mobileLink" (click)="change.emit('footer')"/>
    <img class="app banner footer" *ngIf="!!isApp && !!brandingData?.footer?.mobileLink" [ngClass]="{ configure: isConfigure }" [src]="brandingData.footer.mobileLink" (click)="change.emit('footer')"/>

    <image-placeholder class="desktop footer" *ngIf="!isApp && isConfigure && !brandingData?.footer?.link" [icon]="'scenic'" [text]="'FOOTER IMAGE PLACEHOLDER'" (click)="change.emit('footer')"></image-placeholder>
    <image-placeholder class="mobile footer" *ngIf="!isApp && isConfigure && !brandingData?.footer?.mobileLink" [icon]="'scenic'" [text]="'FOOTER IMAGE PLACEHOLDER'" (click)="change.emit('footer')"></image-placeholder>
    <image-placeholder class="app footer" *ngIf="!!isApp && isConfigure && !brandingData?.footer?.mobileLink" [icon]="'scenic'" [text]="'FOOTER IMAGE PLACEHOLDER'" (click)="change.emit('footer')"></image-placeholder>
  </ng-container>
</div>
`,
    styleUrls: ['branding-wrapper.scss'],
    standalone: true,
    imports: [SocialLinksComponent, MatButtonModule, FooterLinksComponent, CommonModule, ImagePlaceholderComponent ],
})
export class BrandingWrapperComponent {
  @Input() brandingData: BrandingData
  @Input() hideHeader = false
  @Input() hideSocial = false
  @Input() hideFooter = false
  @Input() hideFooterLinks = false
  @Input() hideAll = false
  @Input() isConfigure = false
  @Input() isApp = false
  @Output() change: EventEmitter<BrandOption> = new EventEmitter()
  joiTemplate = getJoiTemplate()
  FontCSS = FontCSS

  changeSocial(event: any) {
    if (!this.isConfigure) return
    event.stopPropagation()
    this.change.emit('social')
  }
}

